import React, { useState } from 'react'

const StatusBadge = ({ status }) => {
  if (!status) return null
  const isRequired = status === 'required'
  return (
    <span className={`adas-detail__status-badge ${isRequired ? 'required' : 'potential'}`}>
      {isRequired ? 'Required' : 'Potential'}
    </span>
  )
}

const SensorInsights = ({ sensorId, sensorInsights, forceOpen }) => {
  const [open, setOpen] = useState(false)
  const isOpen = forceOpen || open
  const insight = (sensorInsights || []).find(s => s.sensorId === sensorId)
  if (!insight || !insight.conditions || !insight.conditions.length) return null

  return (
    <div className='adas-detail__insights'>
      <button className='adas-detail__insights-toggle' onClick={() => setOpen(!open)}>
        {insight.sensorName || 'Sensor'} Insights {isOpen ? '▲' : '▼'}
      </button>
      {isOpen && (
        <div className='adas-detail__insights-content'>
          {insight.conditions.map((cond, i) => (
            <div key={i} className='adas-detail__insight-condition'>
              <span className='adas-detail__insight-component'>{cond.component}</span>
              {cond.items && cond.items.map((item, j) => (
                <div key={j} className='adas-detail__insight-item'>
                  <span>{item.label}</span>
                  {item.lineReferences && <span className='adas-detail__insight-ref'> — {item.lineReferences}</span>}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const formatPrice = (amount) => {
  return `$ ${(amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

const AdasSections = ({ report, allowViewPricing }) => {
  const [expandAll, setExpandAll] = useState(false)
  const services = (report.adas && report.adas.services) || []
  const sensorInsights = report.sensorInsights || []
  const collision = report.adas && report.adas.vinDecodeData && report.adas.vinDecodeData.collision

  if (!services.length) {
    return <p style={{ color: '#69787F', marginTop: 24 }}>No ADAS services on this report.</p>
  }

  // Group by categoryName, then by sensorName
  const categories = {}
  services.forEach(svc => {
    const cat = svc.categoryName || 'Uncategorized'
    if (!categories[cat]) categories[cat] = {}
    const sensor = svc.sensorName || 'General'
    if (!categories[cat][sensor]) categories[cat][sensor] = { services: [], sensorId: svc.rawSensorId || svc.sensorId }
    categories[cat][sensor].services.push(svc)
  })

  return (
    <div className='adas-detail__report-card'>
      <div className='adas-detail__report-header'>
        <div className='adas-detail__report-header-left'>
          <h3 className='adas-detail__report-title'>ADAS Report</h3>
          <label className='adas-detail__collision-check'>
            <input type='checkbox' checked={!!collision} readOnly />
            <span>Vehicle was involved in a collision</span>
          </label>
        </div>
        <div className='adas-detail__report-header-right'>
          <button className='adas-detail__btn-safety'>Safety Systems</button>
          <button className='adas-detail__btn-more'>⋯</button>
        </div>
      </div>

      <div>
        {Object.entries(categories).map(([catName, sensors]) => (
          <div key={catName}>
            <div className='adas-detail__category-row'>{catName}</div>

            {Object.entries(sensors).map(([sensorName, { services: sensorServices, sensorId }]) => (
              <div key={sensorName}>
                <div className='adas-detail__sensor-header'>{sensorName}</div>

                {sensorServices.map(svc => (
                  <div key={svc._id} className='adas-detail__service-row'>
                    <div className='adas-detail__service-name'>
                      <span>{svc.operation ? svc.operation.name : '—'}</span>
                      {svc.calibrationType && (
                        <span className='calibration-type'>({svc.calibrationType})</span>
                      )}
                    </div>
                    <div className='adas-detail__service-status'>
                      <span className='adas-detail__meta-label'>Status:</span>
                      <StatusBadge status={svc.recommendedStatus} />
                    </div>
                    {allowViewPricing && (
                      <div className='adas-detail__service-price'>
                        <span className='adas-detail__meta-label'>Price:</span>
                        <span className='adas-detail__price-value'>{formatPrice(svc.amount)}</span>
                      </div>
                    )}
                    <span className='adas-detail__service-more'>⋯</span>
                  </div>
                ))}

                <SensorInsights sensorId={sensorId} sensorInsights={sensorInsights} forceOpen={expandAll} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default AdasSections
